<template>
    <div v-if="ids.length" class="fa-wrap">
        <div class="fa-thumbs">
            <button v-for="(image, index) in images" :key="image.id" type="button" class="fa-thumb" :aria-label="'Open image ' + (index + 1)" @click="show(image)">
                <img v-if="image.url" :src="image.url" :alt="'Attached image ' + (index + 1)" />
                <v-icon v-else-if="image.failed" small aria-hidden="true">mdi-image-broken-variant</v-icon>
                <v-progress-circular v-else indeterminate size="16" width="2" aria-hidden="true" />
            </button>
        </div>

        <v-dialog v-model="lightbox" max-width="1000">
            <v-card>
                <v-btn icon class="fa-close" aria-label="Close image" @click="lightbox = false"><v-icon>mdi-close</v-icon></v-btn>
                <img v-if="current" :src="current.url" alt="Attached image" class="fa-full" />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    // Zeigt die Screenshots eines Beitrags. Die Bilder sind nur fuer Einreicher und Admins abrufbar und werden einzeln nachgeladen.
    export default {
        name: "FeedbackAttachments",
        props: {
            itemId: { type: Number, required: true },
            // Ids der Bilder, entweder Zahlen oder Objekte mit id
            attachments: { type: Array, default: () => [] }
        },
        data() {
            return {
                images: [],
                lightbox: false,
                current: null,
                auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH)
            }
        },
        computed: {
            ids() {
                return this.attachments.map((a) => (typeof a === "object" ? a.id : a))
            }
        },
        watch: {
            ids: {
                immediate: true,
                handler() {
                    this.load()
                }
            }
        },
        methods: {
            load() {
                this.images = this.ids.map((id) => ({ id, url: "", failed: false }))
                this.images.forEach((image) => {
                    this.$http
                        .post(
                            process.env.VUE_APP_APIURL + "/feedback/items/" + this.itemId + "/attachments/" + image.id,
                            { user: localStorage.getItem("user"), company_id: localStorage.getItem("company_id") },
                            { headers: { Authorization: this.auth } }
                        )
                        .then((response) => {
                            image.url = "data:" + response.body.mime + ";base64," + response.body.data
                        })
                        .catch(() => {
                            image.failed = true
                        })
                })
            },
            show(image) {
                if (!image.url) return
                this.current = image
                this.lightbox = true
            }
        }
    }
</script>

<style scoped>
    .fa-thumbs {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
    .fa-thumb {
        width: 96px;
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(128, 128, 128, 0.4);
        border-radius: 10px;
        overflow: hidden;
        background: transparent;
        cursor: zoom-in;
        padding: 0;
    }
    .fa-thumb:focus-visible {
        outline: 2px solid var(--v-primary-base);
        outline-offset: 2px;
    }
    .fa-thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .fa-full {
        display: block;
        max-width: 100%;
        max-height: 85vh;
        margin: 0 auto;
    }
    .fa-close {
        position: absolute;
        top: 6px;
        right: 6px;
        z-index: 1;
        background: rgba(0, 0, 0, 0.55) !important;
        color: white !important;
    }
</style>
